module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "id": "vol-1-copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-copyright-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Macro Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Chicago, Illinois")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents are products of the author’s imagination or are used fictitiously and are not to be construed as real. Any resemblance to actual events, locales, organizations, or persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_c('i', [_vm._v("Was it Good For You Too?")]), _vm._v(" @ 2018 by Naleighna Kai")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Trade Paperback ISBN:  9780982682906")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Ebook ISBN: 9780982682982")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever or by any means including electronic, mechanical or photocopying, or stored in a retrieval system without written permission of the author, except in the case of brief quotations embodied in critical articles and reviews. For permission, contact Naleighna Kai at www.naleighnakai.com.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("Cover designed by: J. L. Woodson www.woodsoncreativestudio.com")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Interior design by: Lissa Woodson www.woodsoncreativestudio.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-472f20f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001copyright.vue
// module id = 69
// module chunks = 0